export default class MemberSettings {
    static fromData(data)
    {
        if (!data) {
            return;
        }

        let memberSettings = new MemberSettings();
        memberSettings.defaultInvoiceReceiver = data.defaultInvoiceReceiver;
        memberSettings.defaultPaymentMethod = data.defaultPaymentMethod;
        memberSettings.isDunningActive = data.isDunningActive;
        memberSettings.isDunningStopActive = data.isDunningStopActive;
        memberSettings.isUsedAsDefaultInvoiceReceiver = data.isUsedAsDefaultInvoiceReceiver;
        memberSettings.paymentInterval = data.paymentInterval;
        memberSettings.sepaMandateAvailable = data.sepaMandateAvailable;
        memberSettings.currentDefaultSepa = data.currentDefaultSepa;

        Object.seal(memberSettings);
        return memberSettings;
    }
}
